/* global Papa */

"use strict";

// Constructor
var Tablesection5 = function () {
    var $table_counter = 0;
    var $tables = [];
    $(".csv-table-section5").each(function () {
        var $header; // The header row
        var $footer; // The footer row
        var $container = $(this);
        var $configuration = $container.data("configuration"); // The configuration object from the data attribute
        var $table_css_class = $configuration.style ? $configuration.style : "";
        // var $decimal_places = typeof $configuration.decimal_places === "undefined" ? false : $configuration.decimal_places; //Decimal places to show
        var $decimal_places = 0; //Decimal places to show
        var $forgroup_filter = [];
        var $institutions = [];
        var $disciplines = [];
        var $column_filters = [];
        var $total_columns_index = [];

        // Pulls the CSV data in json
        Papa.parse($configuration.url, {
            download: true,
            dynamicTyping: false,
            skipEmptyLines: true,
            complete: function ($json) {

                // Increment the table counter to use for IDs etc
                $table_counter++;

                // Process the data
                $configuration.header ? ($header = $json.data.shift()) : "";
                $configuration.footer ? ($footer = $json.data.pop()) : "";

                // Output the HTML structure for the table
                var $html = "";
                var $highlight_column = [];
                $html += '<table class="' + $table_css_class + '">';

                // Add the header
                if ($configuration.header) {
                    // Start the header column
                    $html += "<thead><tr>";
                    // Addind the group column
                    // $html += "<th>forgroup</th>";

                    // Go through all the header cell

                    $($header).each(function ($index, $value) {
                        // console.log($value.substr(0, $value.indexOf(' ')));
                        $value.substr(0, $value.indexOf(' ')).length === 2 ? $highlight_column.push($index) : ''; // If column is 2 digit mark to highlight

                        var $forcode = $value.substring(0, 2);
                        var $cell_class = "";
                        // Add class to second col to align text
                        $index === 1 ? $cell_class = "left_align" : '';
                        // Add the class and cell value for the header
                        $html += "<th data-index='" + $index + "' data-forcode='" + $forcode + "' class='" + $cell_class + "'>" + $value + "</th>";
                        // If this is a total cell add to array to make background darker
                        $value.toLowerCase().indexOf('total') !== -1 ? $total_columns_index.push($index) : '';

                        $column_filters.push({ index: $index + 1, label: $value });
                        // console.log($value.substr(0, $value.indexOf(' ')))

                        if ($value.substr(0, $value.indexOf(' ')).length === 2) {
                            $disciplines.push({ code: $value.substr(0, $value.indexOf(' ')), label: $value.substr($value.indexOf(' ') + 1) })
                        }
                    });

                    // console.log($disciplines);

                    $html += "</tr></thead>";
                }

                // console.log($highlight_column);
                // Addthe body
                if ($json.data) {
                    $html += "<tbody>";

                    var $forgroup = "";
                    var $forgroup_label = "";
                    var $forgroup_class = "";
                    $($json.data).each(function ($index, $row) {

                        // If the FoR code is one or 3 numbers long add the Zero prefix
                        $row[0].length < 2 || $row[0].length === 3 ? $row[0] = "0" + $row[0] : '';

                        $institutions.push({ label: $row[0] });

                        // Add the group class to the row if it is the first item
                        $html += '<tr class="' + $forgroup_class + '">';

                        // Go through each cell and add
                        $($row).each(function ($index, $cell) {
                            var $cell_class = "";

                            // Make sure the value in the cell is 1 decimal place and thousand seperated
                            if ($decimal_places && $index !== 0 && $index !== 1 && $cell !== "-" && $cell !== "n/a") {
                                $cell = parseFloat(Number($cell.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                                $cell = Number($cell).toLocaleString() // Not sure why we need this
                            }

                            // Make sure the second column containing the FoR name is left aligned
                            // $index === 1 ? $cell_class = "left_align" : '';

                            // If cell is N/A add a class to fade
                            $cell === 'n/a' ? $cell_class += "fade" : '';

                            // If cell is marked to highlight
                            $highlight_column.indexOf($index) !== -1 ? $cell_class += " highlight" : ''; // If cell marked to highlight

                            // If the cell is part of the total cell array mark it to change the background color
                            $total_columns_index.indexOf($index) !== -1 ? $cell_class += "total_cell" : '';

                            // Add the cell data and class
                            $html += "<td class='" + $cell_class + "'>" + $cell + "</td>";
                        });

                        $html += "</tr>";
                    });
                    $html += "</tbody>";
                }

                // Add the footer
                if ($configuration.footer) {

                    // Start of footer
                    $html += "<tfoot><tr>";
                    // Add a blank column for the total
                    // $html += "<td></td>";

                    // Go through each footer cell
                    $($footer).each(function ($index, $value) {
                        // Make sure the value is 1 decimal place and has thousand seperator
                        if ($decimal_places && $index !== 0 && $index !== 1 && $value !== "-") {
                            $value = parseFloat(Number($value.replace(/,\s?/g, ""))).toFixed($decimal_places).toLocaleString();
                            $value = Number($value).toLocaleString() // Not sure why we need this
                        }
                        // Add the value
                        $html += "<td>" + $value + "</td>";
                    });

                    // Close the footer
                    $html += "</tr></tfoot>";
                }

                // Close the table
                $html += "</table>";

                // Add the table on the page
                $container.html($html);



                // Create the filters for FoR group
                var $filter_html = "";

                // Go through the filter array
                $($disciplines).each(function ($index, $data) {

                    // Add the filter markup
                    $filter_html +=
                        "<li class='table_group_" + $table_counter + "'>" +
                        "<input type='checkbox' id='for-" + $table_counter + "_" + $data["code"] + "' data-table-target='" + $table_counter + "'  value='" + $data["code"] + "'/>" +
                        "<label for='for-" + $table_counter + "_" + $data["code"] + "'>" + $data["code"] + " " + $data["label"] + "</label>" +
                        "</li>";
                });

                // Add the FoR filter
                $container.closest('.section5-tables').find(".buttons.widget-container .list").html($filter_html);


                // Create the filters for FoR group
                var $filter_html = "";

                // Go through the filter array
                $($institutions).each(function ($index, $data) {

                    // Add the filter markup
                    $filter_html +=
                        "<li class='table_group_" + $table_counter + "'>" +
                        "<input type='checkbox' id='institution_filter_" + $table_counter + "_" + $index + "' data-table-target='" + $table_counter + "'  value='" + $data["label"] + "'/>" +
                        "<label for='institution_filter_" + $table_counter + "_" + $index + "'>" + $data["label"] + "</label>" +
                        "</li>";
                });

                // Add the FoR filter
                $container.closest('.section5-tables').find(".dropdown.widget-container .list").html($filter_html);




                // Make the dataTable
                var $columnsDefs;

                // Show only 8 columns on the display
                $columnsDefs = [
                    {
                        targets: 0,
                        searchable: true,
                        visible: true
                    },
                    {
                        // targets: [0, 1, $header.length - 1, $header.length], // We can make this a configuration
                        targets: ["_all"],
                        visible: true
                    },
                    {
                        targets: ["_all"],
                        searchable: false,
                        visible: false
                    }
                ];
                $configuration["columnDefs"] = $columnsDefs;

                // Make the table a Datatable
                $tables['table_' + $table_counter] = $container.find("table").DataTable($configuration);


                var $visible = [];
                var $hidden = [];
                var $datatable = $tables['table_' + $table_counter];

                // Bind the change action to the filter checkboxes
                $(".dropdown.widget-container .list li.table_group_" + $table_counter + " input").change(function () {

                    // When a checkbox is ticked go through the list and build the search filter
                    var $value = '';
                    var $table_target = $(this).data('table-target');
                    var $counter = 0;

                    $(this).closest('.dropdown.widget-container').find("input:checked").each(function () {
                        $value += $(this).val() + "|";
                        $counter++;
                    })

                    // console.log($value);

                    // After collecting all the values check if there is anything to filter
                    if ($value) {
                        // Use a regex to filter the full value
                        // console.log($table_target);
                        // console.log($tables['table_' + $table_target]);
                        $tables['table_' + $table_target].search("^\\s*(" + $value + ")\\s*$", true, false, true).draw();
                        $(this).closest('.widget-container').find('.selected span').html($counter);

                    } else {
                        // If no checkbox is ticked then show everything
                        $tables['table_' + $table_target].search('').draw();
                        $(this).closest('.widget-container').find('.selected span').html('All');
                    }

                });


                // Bind the change action to the filter checkboxes
                $(".buttons.widget-container .list li.table_group_" + $table_counter + " input").change(function () {

                    // When a checkbox is ticked go through the list and build the search filter
                    var $value = '';
                    var $table_target = $(this).data('table-target');
                    var $counter = 0;
                    var $selected = [];
                    var $datatable = $tables['table_' + $table_target];


                    $(this).closest('.buttons.widget-container').find("input:checked").each(function () {
                        $value += $(this).val() + "|";
                        $counter++;
                        $selected.push(parseInt($(this).val()));
                    })

                    // console.log($selected);

                    // After collecting all the values check if there is anything to filter
                    if ($value) {
                        // Use a regex to filter the full value
                        $(this).closest('.widget-container').find('.selected span').html($value.slice(0, -1).replace(/\|/g, ", "));

                        // Go through the columns and check if the for is in it the selected array
                        $datatable.columns().every(function ($index) {
                            var $forcode = $(this.header()).data('forcode');

                            if ($index > 0) {
                                // console.log('For code from header',$forcode);

                                if ($selected.indexOf($forcode) > -1 || $selected.indexOf(Number($forcode)) > -1) {
                                    this.visible(true, false);
                                } else {
                                    this.visible(false, false);
                                }
                            }
                        });
                        $datatable.columns.adjust().draw(false)

                    } else {
                        $(this).closest('.widget-container').find('.selected span').html('All');
                        $datatable.columns().visible(true);
                    }

                    $datatable.columns.adjust().draw(false)
                });


                // On page load check if there is a FOR code in the url, if there is then tick the box in the 
                // filter dropdown and filter the table
                if (getForFromURL()) {
                    var $forFromURL = getForFromURL();
                    setTimeout(function () {
                        $(".buttons.widget-container .list li.table_group_" + $table_counter + " input[value='" + $forFromURL + "']").prop('checked', true);
                        $(".buttons.widget-container .list li.table_group_" + $table_counter + " input[value='" + $forFromURL + "']").change();
                    }, 200);
                }

            },
            error: function ($err, $file, $inputElem, $reason) {

                $container.closest(".collapsible-box").addClass("no-data");
                if ($err["message"] === "Not Found" || $err["message"] === "") {
                    var $textfile = $configuration.url.substr(0, $configuration.url.lastIndexOf("/") + 1) + "no.table.footnote.txt"; // remove everything after the last backslash
                    var $error_message = "Data not found";
                    $.ajax({
                        url: $textfile
                    })
                        .done(function ($data) {
                            $data ? ($error_message = $data) : "";
                            $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                        })
                        .fail(function ($error) {
                            $container.replaceWith("<div class='no-table not-found'>" + $error_message + "</div>");
                        });
                }
            }
        });
    });

    function getForFromURL() {
        var $vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            $vars[key] = value;
        });
        if ($vars['for']) {
            var $forcode = $vars['for'].substring(0, 2);
            return $forcode;
        } else {
            return false;
        }
    }

};

module.exports = Tablesection5;
